export { default } from "./ServerError-component";
